<form role="form" class="form-horizontal">

	<div class="form-group row">
		<label class="control-label col-md-1">N° PDP</label>
		<div class="col-md-3">
			<input id="numeroPdp" type="text" placeholder="N&deg; PDP"
				class="form-control" [(ngModel)]="searchCriteria.numeroPdp"
				(ngModelChange)="onNumeroPdpChange()" />
		</div>
		<label class="col-md-1 control-label" for="perimetreReferent">Mon
			Périmètre Référent</label>
		<div class="col-md-3">
			<div class="checkbox">
				<label> <input type="checkbox" name="monPerimetreReferent"
					[(ngModel)]="searchCriteria.monPerimetreReferent"
					(ngModelChange)="onPerimetreReferentChange($event)" />
				</label>
			</div>
		</div>
	</div>
	<div class="form-group">
		<agence-filterable-selector [id]="'filtreAgence'"
			[disabled]="userRole !== 'CCE'" [labelClass]="'col-md-1'"
			[fieldClass]="'col-md-3'" [selectedAgenceId]="searchCriteria.agence"
			(selectedAgenceChange)="onAgenceChange($event)">
		</agence-filterable-selector>
		<antenne-filterable-selector [id]="'filtreAntenne'"
			[disabled]="userRole !== 'CCE'" [labelClass]="'col-md-1'"
			[fieldClass]="'col-md-3'" [agenceId]="searchCriteria.agence"
			[selectedAntenneId]="searchCriteria.antenne"
			(selectedAntenneChange)="onAntenneChange($event)">
		</antenne-filterable-selector>
	</div>
	<div class="form-group">
		<groupement-filterable-selector [id]="'filtreGroupement'"
			[labelClass]="'col-md-1'" [fieldClass]="'col-md-3'"
			[agenceId]="searchCriteria.agence"
			[antenneId]="searchCriteria.antenne"
			[selectedGroupementId]="searchCriteria.groupement"
			(selectedGroupementChange)="onGroupementChange($event)">
		</groupement-filterable-selector>
		<parc-filterable-selector [id]="'filtreParc'"
			[labelClass]="'col-md-1'" [fieldClass]="'col-md-3'"
			[agenceId]="searchCriteria.agence"
			[antenneId]="searchCriteria.antenne"
			[groupementId]="searchCriteria.groupement"
			[selectedParcId]="searchCriteria.parc"
			(selectedParcChange)="onParcChange($event)">
		</parc-filterable-selector>
	</div>
	<div class="form-group">
		<label class="col-md-1 control-label" for="entreprise">Entreprise</label>
		<div class="col-md-3">
			<no-input-reset-filterable-select [inputClass]="'form-control'"
				[list]="entreprises" [resetCommand]="resetCommands"
				[labelGetter]="getEntrepriseName"
				(selectedItemChange)="onEntrepriseSelected($event)">
			</no-input-reset-filterable-select>
		</div>
	</div>
	<div class="form-group">
		<label class="col-md-1 control-label" for="entreprise">Général/Spécfique</label>
		<div class="col-md-3">
			<checkbox-list [id]="'choixTypePdp'" [wildcardOptionLabel]="'Tous'"
				[itemList]="typePdpOptions" [labelGetter]="getTypePdpLabel"
				[preselectionFunction]="typePdpShouldBeSelectedByDefaut"
				[resetCommands]="resetCommands"
				(selectedItemsChange)="onTypePdpSelected($event)">
			</checkbox-list>
		</div>
		<label class="col-md-1 control-label" for="entreprise">Etat</label>
		<div class="col-md-3">
			<checkbox-list [id]="'choixEtat'" [wildcardOptionLabel]="'Tous'"
				[itemList]="etatOptions" [labelGetter]="getEtatLabel"
				[preselectionFunction]="etatPdpShouldBeSelectedByDefaut"
				[resetCommands]="resetCommands"
				(selectedItemsChange)="onEtatPdpSelected($event)">
			</checkbox-list>
		</div>
		<label class="col-md-1 control-label" for="entreprise">Validité</label>
		<div class="col-md-3">
			<checkbox-list [id]="'choixTypePdp'" [wildcardOptionLabel]="'Tous'"
				[itemList]="validiteOptions" [labelGetter]="getValiditeLabel"
				[preselectionFunction]="validitePdpShouldBeSelectedByDefaut"
				[resetCommands]="resetCommands"
				(selectedItemsChange)="onValiditePdpSelected($event)">
			</checkbox-list>
		</div>
	</div>
	<div class="form-group">
		<div class="col-sm-2 text-center">
			<button type="button" class="btn btn-primary"
				(click)="resetfilters()">Réinitialiser</button>
		</div>
	</div>
</form>